import React from 'react';

function Events() {
  return (
    <div className="events">
      <div className="container">
        <h1>Upcoming Events</h1>
        <div className="events-list">
          <p>No upcoming events at the moment. Check back later!</p>
        </div>
      </div>
    </div>
  );
}

export default Events; 